module.exports = __webpack_public_path__ + "img/banner-1-m.e87a8fc2.jpg";